import Chip from '@elementor/ui/Chip';
import Typography from '@elementor/ui/Typography';
import PropTypes from 'prop-types';
import { StyledLevelWrapper } from '@styles/heading-structure.styles';
import { HEADING_STATUS } from '@types/heading';
import { __, sprintf } from '@utils/i18n';
import { injectTemplateVars } from '@utils/inject-template-vars';
import { STATUS_CONFIG, HEADING_LEVEL } from '../../constants';

const HeadingTreeListItemLevel = ({ displayLevel, status }) => {
	const config = STATUS_CONFIG[status];

	return (
		<StyledLevelWrapper>
			<Typography as="span" variant="subtitle2">
				{injectTemplateVars(
					sprintf(
						__('Heading level: {{statusColor}}%s{{/statusColor}}'),
						`${displayLevel.toUpperCase()} – ${HEADING_LEVEL[displayLevel]}`,
					),
					{
						statusColor: ({ children }) => (
							<Typography
								as="span"
								variant="subtitle2"
								sx={{ color: config.statusColor }}
							>
								{children}
							</Typography>
						),
					},
				)}
			</Typography>

			<Chip
				size="small"
				color={config.iconColor}
				variant="filled"
				shape="rounded"
				label={config.chipLabel}
				icon={config.chipIcon}
			/>
		</StyledLevelWrapper>
	);
};

HeadingTreeListItemLevel.propTypes = {
	status: PropTypes.oneOf(Object.values(HEADING_STATUS)).isRequired,
	displayLevel: PropTypes.string.isRequired,
};

export default HeadingTreeListItemLevel;
